var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import '../card/ChatSessionCard.js';
let ChatSessionList = class ChatSessionList extends LitElement {
    constructor() {
        super(...arguments);
        this.chatSessions = [];
    }
    handleCreateSession() {
        this.dispatchEvent(new CustomEvent('create-chat-session', {
            bubbles: true,
            composed: true,
        }));
    }
    handleSessionClick(session) {
        this.selectedChatSession = session;
        this.dispatchEvent(new CustomEvent('chat-session-click', {
            detail: session,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <div class="chat-session-list">
        <div class="chat-session-list__header">
          <h2 class="chat-session-list__title">${this.listTitle || msg('Chat Sessions', { id: 'chatSessionList.title', desc: 'Chat sessions list title' })}</h2>
          <simple-button
            label="${msg('New Conversation', { id: 'chatSessionList.newConversation', desc: 'New conversation button' })}"
            variant="primary"
            size="medium"
            @button-click=${this.handleCreateSession}
          ></simple-button>
        </div>
        <div class="chat-session-list__items">
          ${this.chatSessions.map((session) => html `
              <chat-session-card
                .chatSession=${session}
                .selected=${this.selectedChatSession?.chat_session_id === session.chat_session_id}
                @chat-session-click=${() => this.handleSessionClick(session)}
              ></chat-session-card>
            `)}
        </div>
      </div>
    `;
    }
};
ChatSessionList.styles = css `
    .chat-session-list__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .chat-session-list__title {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 600;
      color: #333;
    }

    .chat-session-list__items {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  `;
__decorate([
    property({ type: Array })
], ChatSessionList.prototype, "chatSessions", void 0);
__decorate([
    property({ type: String })
], ChatSessionList.prototype, "listTitle", void 0);
__decorate([
    property({ type: Object })
], ChatSessionList.prototype, "selectedChatSession", void 0);
ChatSessionList = __decorate([
    localized(),
    customElement('chat-session-list')
], ChatSessionList);
export { ChatSessionList };
//# sourceMappingURL=ChatSessionList.js.map